import React, { useState } from "react";
import "./Partners.css";
import image from "../utils/images/seoimages/partners-hand.webp"; // Update the path to your image

const Partners = () => {
  return (
    <div className="partners">
      <div className="partners-content">
        <div className="partners-text">
          <h2 className="partners-title">
            <span className="title-first-word">Professionella</span> Digitala
            Tjänster
          </h2>
          <section>
            <h3>Våra Samarbetspartners</h3>
            <p>
              Vi erbjuder en heltäckande lösning för dina digitala behov, från
              webbutveckling till SEO-optimering. Genom att samarbeta med
              noggrant utvalda partners, säkerställer vi att varje projekt
              levereras med högsta kvalitet och noggrannhet. Våra samarbeten
              inkluderar:
            </p>
            <ul>
              <li>
                Digitala marknadsföringsbyråer – Vi samarbetar med ledande
                marknadsföringsbyråer för att säkerställa bästa möjliga
                online-synlighet.
              </li>
              <li>
                SEO-experter – Våra SEO-partners hjälper till att maximera din
                webbplats synlighet och driva organisk trafik.
              </li>
              <li>
                Designstudios – Vi samarbetar med kreativa studios för att ge
                din webbplats en modern och användarvänlig design.
              </li>
              <li>
                Webbutvecklare – Genom våra pålitliga utvecklingspartners
                erbjuder vi lösningar för allt från e-handel till avancerade
                webbapplikationer.
              </li>
            </ul>
            <p>
              Kontakta oss idag för en kostnadsfri konsultation och ta reda på
              hur vi kan hjälpa dig att förverkliga ditt digitala projekt.
            </p>
            <button className="consultation-button">Kontakta Oss</button>
          </section>
        </div>
        <div className="partners-image">
          <img src={image} alt="Partners" />
        </div>
      </div>
    </div>
  );
};

export default Partners;
